<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -1 18 18">
    <title>visite mécidale</title>
    <g>
      <path
        d="M9.73224 2.61284C9.73224 2.14685 9.35448 1.76909 8.88849 1.76909C8.4225 1.76909 8.04474 2.14685 8.04474 2.61284V4.07663H6.58095C6.11496 4.07663 5.7372 4.45439 5.7372 4.92038C5.7372 5.38637 6.11496 5.76413 6.58095 5.76413H8.04474V7.22792C8.04474 7.69391 8.4225 8.07167 8.88849 8.07167C9.35448 8.07167 9.73224 7.69391 9.73224 7.22792V5.76413H11.196C11.662 5.76413 12.0398 5.38637 12.0398 4.92038C12.0398 4.45439 11.662 4.07663 11.196 4.07663H9.73224V2.61284Z"
      />
      <path
        d="M4.49945 3.19141C4.49945 3.03608 4.62537 2.91016 4.7807 2.91016H6.27033V1.22266H4.7807C3.69339 1.22266 2.81195 2.10409 2.81195 3.19141V15.0086H2.23242C1.76643 15.0086 1.38867 15.3863 1.38867 15.8523C1.38867 16.3183 1.76643 16.6961 2.23242 16.6961L15.7556 16.6961C16.2216 16.6961 16.5994 16.3183 16.5994 15.8523C16.5994 15.3863 16.2216 15.0086 15.7556 15.0086H14.958V3.19141C14.958 2.1041 14.0765 1.22266 12.9892 1.22266H11.4996V2.91016H12.9892C13.1445 2.91016 13.2705 3.03608 13.2705 3.19141V15.0086L4.49945 15.0086V3.19141Z"
      />
      <path
        d="M12.3201 9.73116C12.3201 10.3198 11.8429 10.797 11.2543 10.797C10.6656 10.797 10.1884 10.3198 10.1884 9.73116C10.1884 9.14252 10.6656 8.66534 11.2543 8.66534C11.8429 8.66534 12.3201 9.14252 12.3201 9.73116Z"
      />
    </g>
  </svg>
</template>
